import { InvoiceDeliveryMethodIntegerEnum } from 'src/shared/models/enums/invoiceDeliveryMethodInteger.enum';
import { InvoiceMissionResponse } from 'src/shared/models/invoiceMission/invoiceMission';
import { InvoiceSendingTypeIntegerEnum } from 'src/shared/models/enums/invoiceSendingTypeInteger.enum';
import { CreateMemberInvoiceReminder } from './createMemberInvoiceReminder';
import { CreateInvoiceSelectInvoiceDeliveryMethod } from './createInvoiceSelectInvoiceDeliveryMethod';
import { SendMemberInvoiceEmail } from './sendMemberInvoiceEmail';
import { SendMemberInvoiceLetter } from './sendMemberInvoiceLetter';
import { InvoiceMissionModalKeys, useInvoiceMissionModalState } from './useInvoiceMissionModalState';
import { MemberInvoiceKivra } from './memberInvoiceKivra';

type InvoiceMissionModalsProps = {
  invoiceMission: InvoiceMissionResponse;
  parsedSendingType: number;
  modalState: ReturnType<typeof useInvoiceMissionModalState>;
};

export const InvoiceMissionModals = (props: InvoiceMissionModalsProps) => {
  const { invoiceMission, parsedSendingType, modalState } = props;

  const { deliveryMethod, modals, resetDeliveryState, setDeliveryMethod, setModal } = modalState;

  const handleButtonClick = (val: InvoiceDeliveryMethodIntegerEnum) => {
    setDeliveryMethod(val);
    if (val === InvoiceDeliveryMethodIntegerEnum.mail) {
      setModal(InvoiceMissionModalKeys.SendEmail, true);
    } else if (val === InvoiceDeliveryMethodIntegerEnum.letter) {
      setModal(InvoiceMissionModalKeys.SendLetter, true);
    } else if (val === InvoiceDeliveryMethodIntegerEnum.kivra) {
      setModal(InvoiceMissionModalKeys.SendKivra, true);
    }
  };

  return (
    <>
      {/* // Välj leveranssätt för utskicket */}
      {modals.deliveryMethod && (
        <CreateInvoiceSelectInvoiceDeliveryMethod
          onSave={resetDeliveryState}
          onClose={resetDeliveryState}
          deliveryMethodCallback={(val: InvoiceDeliveryMethodIntegerEnum) => {
            handleButtonClick(val);
          }}
          openDeliveryMethodModal={modals.deliveryMethod}
          invoiceGroupId={invoiceMission.owner_id || 0}
        />
      )}

      {/* Skapa påminnelse */}
      {modals.createReminder && (
        <CreateMemberInvoiceReminder
          openCreateInvoiceReminderModal={modals.createReminder}
          setOpenCreateInvoiceReminderModal={(val) => setModal(InvoiceMissionModalKeys.CreateReminder, val)}
          invoiceMission={invoiceMission}
          // Påminnelselogik: När det är påminnelse1 så skickar du in 2 || När det är påminnelse2 så skickar du in 3
          reminder={
            parsedSendingType === InvoiceSendingTypeIntegerEnum.Reminder1
              ? InvoiceSendingTypeIntegerEnum.Main
              : InvoiceSendingTypeIntegerEnum.Reminder1
          }
        />
      )}

      {/* Skicka via email */}
      {modals.sendEmail && deliveryMethod === InvoiceDeliveryMethodIntegerEnum.mail && (
        <SendMemberInvoiceEmail
          modalOpen={modals.sendEmail}
          onSave={resetDeliveryState}
          onClose={resetDeliveryState}
          invoiceMission={invoiceMission}
          hideBackdrop
          sendingType={parsedSendingType}
          navigateToInvoiceMission
        />
      )}

      {/* Skicka via brev */}
      {modals.sendLetter && deliveryMethod === InvoiceDeliveryMethodIntegerEnum.letter && (
        <SendMemberInvoiceLetter
          modalOpen={modals.sendLetter}
          onSave={resetDeliveryState}
          onClose={resetDeliveryState}
          invoiceMission={invoiceMission}
          hideBackdrop
          sendingType={parsedSendingType === InvoiceSendingTypeIntegerEnum.NotSet ? InvoiceSendingTypeIntegerEnum.Main : parsedSendingType}
          navigateToInvoiceMission
        />
      )}

      {/* Skicka via Kivra */}
      {modals.sendKivra && deliveryMethod === InvoiceDeliveryMethodIntegerEnum.kivra && (
        <MemberInvoiceKivra
          modalOpen={modals.sendKivra}
          onSave={resetDeliveryState}
          onClose={resetDeliveryState}
          invoiceMission={invoiceMission}
          hideBackdrop
          sendingType={parsedSendingType}
        />
      )}
    </>
  );
};
